module.exports = __webpack_public_path__ + "img/org02.0228b196.png";